const BUNDLE_SKUS = [
    3647,
    3648,
    3649,
    3650
];

const Actions = {
    ORDER_EDIT: 'oe',
    OSS: 'oss'
};

const AJAX_CART_ITEM_CLASS = '.ajaxcart__item';

const ADD_TO_CART_COMPONENT = '#add-to-cart';

const BSG_SKUS = [
    '3555'
];

const POPUP = 'popup';
const PDP = 'pdp';

const Cart = {
    AFTER_CART_LOAD: 'ajaxCart.afterCartLoad',
    BACKDROP_COMPONENT: '#cartBackdrop',
    CHECK_CART_INDICATOR: 'checkCartIndicator',
    CONTAINS_MEMBERSHIP_LINE_ITEM: 'cartContainsMembershipLineItem',
    DISABLE_SHOGUN_ADD_TO_CART_BUTTONS: 'disableShogunAddToCartButtons',
    DRAWER_COMPONENT: '#CartDrawer',
    MODIFY_CART_PROPERTIES: 'modifyCartProperties',
    PARENT_ORDER_NUMBER: 'ontech_oss_parent_ordernum',
    Profinder: {
        CART_TOTAL_AND_HAS_SERVICE: 'profinder-getCartTotalAndHasService'
    },
    Properties:{
        BENEFIT_AMOUNT: '_benefit_amount',
        BENEFIT_APPLIES_TO: '_benefit_applies_to',
        BENEFIT_CODE: '_benefit_code',
        BENEFIT_TYPE: '_benefit_type',
        BENEFIT_VALUE: '_benefit_value',
        COMPARE_AT_PRICE: '_compareAtPrice',
        DYNAMIC_PRICING_REQUIRE_FULL_PRICE_INSTALL: '_dynamicPricingRequireFullPriceInstall',
        GIFT_PARENT_ID: '_giftParentID',
        GIFT_QUANTITY_LOCKED: '_giftQuantityLocked',
        GROUP_ID: '_groupId',
        GWP_UPSELL: '_gwpUpsell',
        UPSELL_TRACKER: '_upsell_tracker',
        SPECIAL_TRACKER:'_special_tracker',
        IS_BUNDLE: '_isBundle',
        IS_FULFILLED: '_is_fulfilled',
        IS_GIFT: '_isGift',
        MASTER_VARIANT: '_masterVariantId',
        MEMBERSHIP: 'Membership',
        ON_SITE_SALES: '_onsitesales',
        OSS_GWP: '_ossGwp',
        PRODUCT_TAGS: '_product_tags',
        SHIPPING_RESTRICTION: '_shipping_restriction',
        SALE_DISCOUNT: '_sale_discount',
        SPECIAL_OFFER: '_special_offer',
        SPECIAL_PRICE: '_special_price',
        UPSELL_PRICE: '_upsell_price',
        UPSELLS: '_upsells'
    },
    REBUILD_CART: 'ontech_cache_rebuildCart',
    REBUILD_CART_DATA: 'ontech_cache_rebuildCartData',
    REMOVE_MEMBERSHIP_BENEFITS: 'removeMembershipBenefits',
    REMOVE_MEMBERSHIP_ITEM: 'removeMembershipItem',
    REMOVE_MONTHLY_MEMBERSHIP_ITEM: 'removeMonthlyMembershipItem',
    Scheduler: {
        HANDLE_RESTRICTION_OSS: 'scheduler-handleRestrictionOSS'
    },
    SlideCart:{
        SPECIAL_OFFER_ITEMS_TO_SHOW: 'specialOfferItemsToShowInSlideCart',
        UPSELL_ITEMS_TO_SHOW: 'upsellItemsToShowInSlideCart'
    },
    Tags:{
        DISABLE_CART_SKU_PDP_LINK: 'disable-cart-sku-pdp-link',
        LIMIT_ONE_PER_ORDER: 'limit-one-per-order',
        Oss: {
            GOOGLE_MINI_GWP: 'oss-google-mini-gwp',
            GOOGLE_MINI_GWP_EXCLUDE: 'oss-google-mini-gwp-excluded'
        },
        Partner: {
            REALTOR_BUNDLE: 'realtor-bundle',
            ROCKET_MORTGAGE_BUNDLE: 'rocket-mortgage-bundle'
        },
        RESTRICTED_IN_CART: 'restrict-in-cart'
    },
    UPDATE_CART_TOTAL_BENEFIT_VALUE: 'updateCartTotalBenefitValue',
    UPDATE_MEMBERSHIP_BENEFITS: 'updateMembershipBenefits',
    UPDATE_CALLBACK: 'cartUpdateCallback',
    UPDATED_QUANTITY: 'ajaxCart.updatedQty',
    UPDATING_QUANTITY: 'ajaxCart.updatingQty',
};

// Client Names 
const ClientNames = {
    ADT_OSS: 'OSS - ADT Home Security',
    ADT_RADIO_SWAP: 'ADT-Radio-Swap',
    ALARM_CONNECTIONS: 'Alarm-Connections',
    ALTHENA: 'Althea',
    AMAZON_DIRECT: 'Amazon-Direct',
    BSG: 'BSG',
    D2C_ADT: 'D2C - ADT',
    D2C_ARLO: 'D2C - Arlo',
    D2C_CALCHIP: 'D2C - CalChip',
    D2C_DISH: 'D2C - DISH',
    D2C_DISH_RETENTION: 'D2C - Dish Retention',
    D2C_GOOGLE_NEST: 'D2C - Google Nest',
    D2C_GO_WIRELESS: 'D2C - GoWireless',
    D2C_MANTELMOUNT: 'D2C - MantelMount',
    D2C_NETGEAR: 'D2C - NETGEAR',
    D2C_ONTECH: 'D2C - OnTech',
    D2C_RING: 'D2C - Ring',
    D2C_ROCKET_MORTGAGE: 'D2C - Rocket Mortgage',
    D2C_REALTOR_COM: 'D2C - Realtor.com',
    D2C_SIMPLISAFE: 'D2C - SimpliSafe',
    D2C_SMARTINSURE: 'D2C - Smartinsure',
    D2C_VETERANS_UNITED: 'D2C - Veterans United',
    D2C_WEMO: 'D2C - Wemo',
    D2C_WYZE: 'D2C - Wyze',
    DishTV_ADT: 'DishTV - ADT',
    HELM_SMART_HOME: 'Helm-Smart-Home',
    OnTech_ADT: 'OnTech - ADT',
    OOMA: 'OOMA',
    OSS: 'OSS',
    RING_COMMUNITY: 'Ring Community Program',
    B2B_CALCHIP: 'CalChip',
    RENTLY: 'Rently',
    REFERRAL_ADT: 'Referral - ADT',
    ASURION:'Asurion',
    ShortName:{
        ADT: 'ADT',
        ALARM_CONNECTIONS: 'Alarm-Connections',
        ALTHENA: 'Althea',
        AMAZON_DIRECT: 'Amazon-Direct',
        ARLO: 'Arlo',
        BSG: 'BSG',
        CALCHIP: 'CalChip',
        COMMUNITY: 'Community',
        DISH: 'Dish',
        GOOGLE: 'Google',
        GOWIRELESS: 'GoWireless',
        HELM: 'Helm',
        MANTELMOUNT: 'MantelMount',
        NETGEAR: 'Netgear',
        OOMA: 'OOMA',
        RING: 'Ring',
        SIMPLISAFE: 'SimpliSafe',
        VETERNS_UNITED: 'Veterans-United',
        WALMART_IN_HOME: 'Walmart-In-Home',
        WEMO: 'Wemo',
        WYZE: 'Wyze',
        RENTLY: 'Rently',
        NRG: 'D2C - NRG',
        ASURION:'Asurion'
    },
    SIMPLISAFE_RADIO_SWAP: 'SimpliSafe - Radio Swap',
    WALMART_IN_HOME: 'Walmart-In-Home'
};

const ADT_CLIENT_NAMES = [
    ClientNames.ADT_OSS,
    ClientNames.D2C_ADT,
    ClientNames.DishTV_ADT,
    ClientNames.OnTech_ADT
];

const ADT_OSS_CLIENT_NAMES = [
    ClientNames.ADT_OSS,
    ClientNames.DishTV_ADT,
    ClientNames.OnTech_ADT
];

const OSS_CLIENT_NAMES = [
    ClientNames.OSS,
    ...ADT_OSS_CLIENT_NAMES
];

// Cookies
const CookiesConstants = {
    AUTH_TOKEN: 'ontech_auth_token',
    AUTH_ROLE: 'ontech_auth_role',
    AUTH_USER: 'ontech_auth_user',
    AUTH_ACTION: 'ontech_auth_action',
    AUTH_ORDER_NUMBER: 'ontech_auth_ordernumber',
    AUTH_EMAIL_ADDRESS: 'ontech_auth_emailaddress',
    CLIENT_NAME: 'ontech_clientname',
    CHECKOUT_PREFIX: 'ontech_checkout_',
    CHECKOUT_SHIPPING_METHOD: 'ontech_checkout_shipping_method',
    CHECKOUT_STATE: 'ontech_checkout_state',
    // Used by SHA for customer refund, don't clear for OSS/Agent
    CUSTOMER_ID: 'ontech_customer_id',
    DISABLE_MEMBERSHIP_ADD: 'ontech_disable_membership_add',
    INDIRECT_PARTNER_CODE: 'ontech_indirectPartnerCode',
    JWT_TOKEN: 'JWT_TOKEN',
    LOG_PREFIX: 'ontech_log_',
    Membership: {
        // Flag indicating membership either in cart or member logged in
        ACTIVE: 'ontech_membership_active',
        // Partner config setting
        DISABLED: 'ontech_membership_disabled',
        // flag to display we removed membership because you're already a member message NO NEED TO
        // CLEAR ON HOME
        MONTHLY_SHW_REMOVED_MESSAGE: 'ontech_monthly_membership_showRemovedMessage',
        // Flag to display "We've updated your cart" message NO NEED TO CLEAR ON HOME
        PREFIX: 'ontech_membership_',
        SHOW_PRICING_UPDATE_MESSAGE: 'ontech_membership_showPricingUpdatedMessage',
        // flag to display we removed membership because you're already a member message
        // NO NEED TO CLEAR ON HOME
        SHOW_REMOVED_MESSAGE: 'ontech_membership_showRemovedMessage'
    },
    OrderEdit: {
        ORDER_NUMBER: 'ontech_orderedit_orderNumber',
        ORIGINAL: 'ontech_orderedit_original',
        PREFIX: 'ontech_orderedit_',
        SUB_TOTAL_PRICE: 'ontech_orderedit_subtotalPrice',
        TOTAL_PRICE: 'ontech_orderedit_totalPrice'
    },
    Oss:{
        CUSTOMER_NAME: 'ontech_oss_customerName',
        CUSTOMER_EMAIL: 'ontech_oss_customerEmail',
        REDIRECT_URL: 'ontech_oss_redirectUrl',
        ORIGINAL_URL: 'oss_originUrl',
        PARENT_ORDER_NUMBER: 'ontech_oss_parent_ordernum',
        PARENT_ORDER_MEMBER: 'ontech_oss_parentOrderMember',
        PREFIX: 'ontech_oss_',
        TECH_DELIVERED: 'ontech_oss_techDelivered',
        VALID_GWPS: 'ontech_oss_validGwps'
    },
    PARENT: 'parent',
    Partners: {
        PARENT_PARTNER_ID: 'ontech_parent_partner_id',
        PREFIX: 'ontech_partner_',
        HIDE_EMPTY_SLIDE_CART_CONTENTS: 'ontech_partner_hideEmptySlideCartContents',
        PARTNER_ID: 'ontech_partner_id',
        SHOW_CART_ITEMS_REMVOED_MESSAGE: 'ontech_partner_showCartItemsRemovedMessage',
        SHOW_EXCLUSIVE_CART_CLEARED_MESSAGE: 'ontech_partner_showExclusiveCartClearedMessage',
        SKIP_CART: 'ontech_partner_skipCart',
        SLIDE_CART_DISABLED: 'ontech_partner_slideCartDisabled',
        URL: 'ontech_partner_url'
    },
    PROFINDER_LOGOUT: 'ontech_profinder_logout',
    RANDOM_NUMBER_CALL: 'random_number_call',
    RNG_URL:'random_url',
    SCHEDULER_PREFIX: 'ontech_scheduler_',
    SHA: 'ontech_sha_',
    SHA_ACTIVE: 'ontech_sha_active',
    SHA_IN_CART: 'ontech_sha_inCart',
    THEME_ID: 'ontech_theme_id'
};

const EXCLUDE_DOMAINS = [
    'www.test.ontechsmartservices.com',
    'www.ontechsmartservices.com',
    'ontechsmartservices.com'
];

const HttpStatusCodes = {
    OK: 200,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    UNPROCESSABLE: 422,
    INTERNAL_SERVER_ERROR: 500
};

const IntegrationChannel = {
    ALL: 'ALL',
    AMAZON_INTEGRATION: 'AMAZON_INTEGRATION',
    HANDY: 'HANDY',
    INTEGRATED_CART: 'INTEGRATED_CART',
    ONTECH: 'ONTECH',
    ONTECH_API_INTEGRATION: 'ONTECH_API_INTEGRATION',
    ONTECH_BATCH_INTEGRATION: 'ONTECH_BATCH_INTEGRATION',
    VIASAT_INTEGRATION: 'VIASAT_INTEGRATION'
};

const Keycodes = {
    ENTER: 13,
    ESCAPE: 27
};

const LOADING_AJAX_CLASS = '.loadingComponentAjax';
const LOADING_RENEWAL_COMPONENT = '#loading-spinner-renewal';
const LOADING_SHOGUN_COMPONENT = '#loadingComponentForShogun';

const Membership = {
    BUTTON_CLASS: '.membership-button',
    ADD_BUTTON_CLASS: '.membership-add-button',
    ADD_BUTTON_SHOGUN_CLASS: '.add-membership-button',
    ADD_BUTTON_INPUT_CLASS: 'input.membership-add-button',
    ADD_BUTTON_BUTTON_CLASS: 'button.membership-add-button',
    Discounts: {
        _10_PERCENT_OFF_PRODUCTS_AND_SERVICES: '10_PERCENT_OFF_PRODUCTS_AND_SERVICES',
        _20_PERCENT_OFF_SELECT_ITEMS: '20_PERCENT_OFF_SELECT_ITEMS',
        _1_FREE_INSTALLATION: '1_FREE_INSTALLATION',
        _1_YEAR_REMOTE_TECH_SUPPORT: '1_YEAR_REMOTE_TECH_SUPPORT'
    },
    DiscountTypes: {
        PERCENT_OFF: 'PERCENT_OFF',
        FIXED_PRICE: 'FIXED_PRICE',
        FREE_INSTALLATION: 'FREE_INSTALLATION',
        FREE_ITEM: 'FREE_ITEM'
    },
    DiscountTitles: {
        MULTIPLE_SERVICE_DISCOUNT: 'Multiple Service Discount'
    },
    OG_BUTTON: 'og-button',
    OG_MEMBERSHIP_BUTTON_CLASS: '.og-membership-button',
    REMOVE_BUTTON_CLASS: '.membership-remove-button',
    Skus: {
        ALL: ['1780', '1807', '3363'],
        FULL: ['1780', '1807'],
        MONTHLY: ['3363'],
        NON_OSS: ['1780'],
        OSS: ['1807']
    },
    Status:{
        EXISTING: 'existing',
        NEW: 'new',
        RENEWED: "renewed"
    },
    Tags:{
        APPLY_FREE_INSTALL: 'MBAutoApplyFreeInstall',
        EXCLUDE_FROM_BENEFITS: 'MembershipExcludeFromBenefits',
        FREE_INSTALL: 'MemberFreeInstall',
        MEMBER_20_PERCENT_OFF_ADVANCE_INSTALL: 'Member20%OffAdvancedInstalls',
        MEMBER_20_PERCENT_OFF_ADVANCE_INSTALL_TAG: 'member20PercentOffAdvancedInstallsTag'
    }
};

const Metafields = {
    CONFIRMATION_POP_UP_NAMESPACE: 'add_to_cart_message',
    Keys: {
        DROPSHIP_PRODUCT: 'interorg-dropship-required'
    }

};

const NoteAttribute = {
    Partners: {
        ADT: { //TODO begin breaking up note attributes into default attributes that all orders share and partner or specific attributes
            Third_Party: {
                OE: '3rd Party OE#',
                AGENT_ID: '3rd Party Agent ID#'
            }
        }
    },
    _20_PERCENT_OFF_SELECT_ITEMS: '_20_PERCENT_OFF_SELECT_ITEMS',
    ROLLBAR_SESSION_ID: 'Rollbar Session Id',
    AGENT_ID: 'Agent ID',
    APPOINTMENT_FROM: 'Appointment Time From',
    APPOINTMENT_TO: 'Appointment Time To',
    APPOINTMENT_WINDOW: 'Appointment Window',
    CHANNEL_NOTES: 'Channel Notes',
    CLIENT_NAME: 'ClientName',
    CONSENT_TO_CALL: 'Consent To Call',
    CUSTOMER_NOTE: 'Customer Note',
    DYNAMIC_ATTRIBUTES: 'Dynamic Attributes',
    EVENT_CALLBACK_URL: 'Event Callback URL',
    GIFT_CARD_ORDER_ID: 'Gift Card ID',
    INTEGRATION_CHANNEL: 'Integration Channel',
    INTEGRATION_PARTNER_ID: 'Integration Partner ID',
    IS_FOLLOW_ON_ORDER: 'Is Follow On',
    LINE_FULFILLMENT: 'Line Fulfillment: ',
    LOGGED_IN: 'Logged In',
    MEMBER_FREE_INSTALL_TAG: '_memberFreeInstallTags',
    MEMBER_ORDER_ID: 'Member Order ID',
    MEMBERSHIP: 'Membership',
    MONTHLY_MEMBERSHIP: 'Ordergroove Order ID',
    OG_DISCOUNT_CODE: 'ogDiscountCode',
    OG_OFFER_IDS: 'og_offer_ids',
    OG_OPTINS: 'og_optins',
    ORDER_EDIT_DELTA: 'Order Edit Delta',
    ORDER_LAST_UPDATED: 'Order Last Updated',
    PARENT: 'Parent',
    PARENT_ORDER_NUMBER: 'ontech_oss_parent_ordernum',
    PARENT_ORDER_ID: 'Parent Order ID',
    PARENT_SHOPIFY_ID: 'Parent Shopify ID',
    PARENT_WORK_ORDER: 'Parent Work Order',
    PARTNER_LINE_ID: 'Partner Trouble Call',
    PARTNER_REFERENCE_ID: 'Partner Reference ID',
    PARTNER_DATA: 'Partner Data',
    PARTNER_ID: 'Partner ID',
    PARTNER_ORDER_ID: 'Partner Order ID',
    PRODUCT_ORDER_ID: 'Product Order ID',
    PRODUCT_SKU: 'Install Product SKUs',
    REFUND_CODE: 'RefundCode',
    RETURN_FOR_CREDIT_END_DATE_ID: 'ReturnForCreditEndDate',
    RETURN_ORDER_ID: 'Return Order id',
    SCHEDULED_DATE: 'Scheduled Date',
    SERVICE_ORDER_ID: 'Service Order ID',
    SHIP_FROM: 'Ship From',
    SHIP_TO: 'Ship To',
    SKU_BASED_TAGGING: 'SkuBasedTagging',
    TECH_DELIVERED_FLAG: 'TechDelivered',
    TECH_DELIVERED_SHIPPING: 'Service Technician Delivery',
    TECH_ID: 'TechId',
    TOTAL_BENEFIT_VALUE: 'TotalBenefitValue',
    TROUBLE_TICKET_REASON: 'Trouble Ticket Reason',
    FOLLOW_ORDER_DETAILS: 'FollowOn Order Details',
    TROUBLE_CALL_PARENT_LINE_IDS: 'Parent Offering Line Ids',
    TROUBLE_CALLED_LINES: 'Line Ids with Trouble Call',
    UPDATE_STEPS: 'Update Steps'
};

const OOMA_SKUS = [
    '3449'
];

const Partners = {
    ADT_OSS: 'ADT_OSS',
    ADT_OSS_HOME_SECURITY: 'OSS_ADT_Home_Security',
    ALARM_CONNECTIONS_OSS: 'Alarm_Connections_OSS',
    ALTHEA_OSS: 'althea-oss',
    AMAZON_OSS: 'Amazon_On_Site_Sales',
    ARLO_OSS: 'ARLO_OSS',
    BSG_OSS: 'BSG_OSS',
    CALCHIP_OSS: 'calchip-oss',
    D2C_ADT: 'adt-att',
    D2C_GOOGLE_NEST: 'D2C-Google-Nest',
    D2C_GOOGLE_NEST_AGENT: 'D2C-Google-Nest-Agent',
    D2C_REALTOR_COM: 'D2C-Realtor.com',
    D2C_ROCKET_MORTGAGE: 'D2C-Rocket-Mortgage',
    DISH_ON_SITE_OSS: 'Dish_On_Site_OSS',
    GOOGLE_OSS: 'Google_OSS',
    HELM_OSS: 'HELM_OSS',
    MANTELMOUNT_OSS: 'mantelmount-oss-id',
    NETGEAR_OSS: 'NETGEAR_OSS',
    ONTECH: 'Ontech_OSS',
    OOMA_OSS: 'Ooma_Oss',
    RING_COMMUNITY: 'Ring_Community_OSS',
    RING_OSS: 'Ring_OSS',
    SIMPLISAFE: 'Simplisafe',
    SIMPLISAFE_OSS: 'SIMPLISAFE_OSS',
    VETERNS_UNITED_OSS: 'Veterans_United_OSS',
    WALMART_IN_HOME_OSS: 'Walmart_In_Home_OSS',
    WEMO_OSS: 'wemo-oss',
    WYZE_OSS: 'WYZE_OSS',
    RENTLY_OSS: 'rently-oss',
    NRG_OSS: 'nrg-oss',
    ASURION_OSS: 'asurion-oss'
};

const Premium = {
    Appointment: {
        TIME_SLOT: '8 am - 9 am',
        TIME_SLOT_NAME: '08a-09a'
    }
}


const ProductTypes = {
    BUNDLE: 'Bundle',
    INSTALL: 'Install',
    MEMBERSHIP: 'Membership',
    PRODUCT: 'Product',
    REMOTE_TECH_SUPPORT: 'RemoteTechSupport',
    SERVICE: 'Service'
};

const PassCheckout = {
    SERVICE_TECH_DELIVERY_RADIO_ID : 'shopify-Service%20Technician%20Delivery-0.00'
}

const RefundCodes = {
    SHA_DISCOUNT: 'SHA-DISCOUNT'
}

const Roles = {
    AGENT: 'AGENT',
    TECH: 'TECH'
}

const SELECT_PLAN_MODAL_COMPONENT = '#selectPlanModal';


const SIMPLISAFE_SKUS = [
    '3536'
];

const Session = {
    TAB_GUID: 'ontech_tabGuid'
};

const ShippingMethods = {
    TECH_DELIVERED: 'Service Technician Delivery',
    UPS_GROUND: 'UPS GROUND'
};

// STATE
const State = {
    ACTION: 'general.action',
    Actions: {
        ACTION_CHANGED: 'onGeneralActionChanged',
        ADT_CS_NUMBER_SET: 'onAdtCsSet',
        ADT_SITE_NUMBER_SET: 'onAdtSiteSet',
        AGENT_CHANGED: 'onAgentChanged',
        CART_ITEM_ADDED: 'onCartItemAdded',
        CART_ITEM_REMOVED: 'onCartItemRemoved',
        CART_MODIFIED: 'onCartModified',
        CART_UPSELL_CHANGED: 'onCartUpsellsChanged',
        CHECKOUT_STATE_CHANGED: 'onCheckoutStateChanged',
        CHECKOUT_SHIPPING_METHOD_CHANGED: 'onCheckoutShippingMethodChanged',
        CLEAR_STORAGE: 'clearOntechStorage',
        CLIENT_NAME_CHANGED: 'onGeneralClientNameChanged',
        CUSTOMER_CHANGED: 'onCustomerChanged',
        FORCED_LOGIN: 'onForcedLogin',
        GET_MEMBER_LEVEL: 'getMemberLevel',
        GET_MEMBERSHIP_LEVEL: 'getMembershipLevel',
        GET_ORDER_DETAIL_DATE: 'getOrderDetailsDate',
        LOAD_APP_1: 'onLoadApp1',
        LOAD_APP_2: 'onLoadApp2',
        LOGOUT: 'onLogout',
        MEMBER: 'onMember',
        MEMBERSHIP_ADD: 'onMembershipAdded',
        MEMBERSHIP_REMOVE: 'onMembershipRemoved',
        MEMBERSHIP_TOTAL_BENEFIT_VALUE_CHANGED: 'onMembershipTotalBenefitValueChanged',
        MONTHLY_MEMBERSHIP_ADDED: 'onMonthlyMembershipAdded',
        MONTHLY_MEMBERSHIP_REMOVED: 'onMonthlyMembershipRemoved',
        NEW_TAB: 'onNewTab',
        ORDER_EDIT: 'onOrderEdit',
        ORDER_EDIT_ORIGINAL_PRICE: 'onOrderEditOriginalPrice',
        ORDER_EDIT_CLIENT_NAME_CHANGED: 'onGeneralOrderEditClientNameChanged',
        OSS_PARENT_ORDER_NUMBER_CHANGED: 'onOssParentOrderNumberChanged',
        OSS_TECH_DELIVERED_CHANGED: 'onOssTechDeliveredChanged',
        OSS_TECH_ID_CHANGED: 'onOssTechIdChanged',
        PRODUCT_AVAILABILITY_CHECK: 'onProductAvailabilityCheck',
        PARTNER_CHANGED: 'onPartnerChanged',
        PARTNER_ID_CHANGED: 'onPartnerIdChanged',
        SET_MEMBERSHIP_ATTRIBUTE: 'setMembershipAttribute',
        UPDATE_TIMEOUT_TIMER: 'onUpdateTimer',
        UPDATE_STATE: 'updateState',
        VENDOR_CUSTOMER_EMAIL: 'vendorCustomerEmail',
        VENDOR_CONTACT_INFO_PAGE_LOAD: 'vendorContactInfoPageLoad',
        VENDOR_SLIDE_CART_DISABLED: 'vendorslideCartDisabled',
        VENDOR_REFERRER_URL: 'vendorReferrer',
        ZIPCODE_CHANGED: 'onZipCodeChanged',
        UP_TRACKER_CHANGED: 'onUpsellChanged',
        SP_TRACKER_CHANGED: 'onSpecialChanged'
    },
    Adt: {
        CS_NUMBER: 'adtNumber.adtCsNumber',
        SITE_NUMBER: 'adtNumber.adtSiteNumber',
        Third_Party: {
            OE: 'adtThirdParty.oeNumber',
            AGENT: 'adtThirdParty.agentId'
        }
    },
    // Don't clear on homepage or will lose agent id during ATT flow
    AGENT_ID: 'agent.id',
    Bundles:{
        _3650: 'bundleAvailability.3650',
        _3649: 'bundleAvailability.3649',
        _3648: 'bundleAvailability.3648',
        _3647: 'bundleAvailability.3647',
        _3638: 'productAvailability.3638',
        _3637: 'productAvailability.3637',
        _3636: 'productAvailability.3636',
        _3635: 'productAvailability.3635',
        _3634: 'productAvailability.3634',
        _3644: 'productAvailability.3644',
        _3646: 'productAvailability.3646',
        _3645: 'productAvailability.3645',
        _3639: 'productAvailability.3639',
        _3641: 'productAvailability.3641',
        _3640: 'productAvailability.3640',
        _3643: 'productAvailability.3643',
        _3642: 'productAvailability.3642'
    },
    Cart:{
        IS_MODIFIED: 'cart.isCartModified',
        UPSELL_DATA: 'cart.upsellData'
    },
    CHECKOUT_SHIPPING_METHOD: 'checkout.shippingMethod',
    CHECKOUT_STATE: 'checkout.state',
    CLIENT_NAME: 'general.clientName',
    Customer: {
        CUSTOMER: 'customer',
        DISCOUNT: 'sha.customerDiscount',
        EMAIL_ADDRESS: 'customer.emailAddress',
        ID: 'customer.id',
        IS_LOGGED_IN: 'customer.isLoggedIn',
        SHA_REFUND: 'sha.customerShaRefunded',
        GUEST_CHECKOUT_EMAIL_ADDRESS: "customer.guestCheckoutEmailAddress"
    },
    FORCED_LOGIN: 'auth.forcedLogin',
    HAVE_QUOTE: 'sha.haveQuote',
    HIDE_EMPTY_SLIDE_CART: 'partner.hideEmptySlideCartContents',
    IS_DROP_SHIP_ORDER: 'orderEdit.isDropShipOrder',
    LOG_ACTIVITY: 'log.activityLog',
    LOG_ORDER_ATTRIBUTE_UPDATE_STEPS: 'log.orderAttributeUpdateSteps',
    Membership: {
        ACTIVE: 'membership.active',
        DAYS_REMAINING_TO_SHOW_RENEWAL: 'membership.daysRemainingToShowRenewal',
        EXPIRATION_DATE: 'membership.expirationDate',
        FREE_INSTALL_OVERRIDE: 'membership.numFreeInstallsOverride',
        FREE_INSTALLS_REDEEMED: 'membership.numFreeInstallsRedeemed',
        FREE_INSTALLS_REMAINING: 'membership.numFreeInstallsRemaining',
        IN_CART: 'membership.inCart',
        IS_ENABLED: 'membership.enabled',
        IS_MEMBER: 'membership.isMember',
        LEVEL: 'membership.level',
        MEMBERSHIP: 'membership',
        MONTHLY_MEMBERSHIP_IN_CART: 'membership.monthlyMembershipInCart',
        OG_DISCOUNT: 'membership.ogDiscount',
        OPTION_CHECKED: 'membership.optionChecked',
        PLAN_ID: 'membership.planId',
        PLAN_SKU: 'membership.planSku',
        PLAN_TITLE: 'membership.planTitle',
        PLAN_VARIANT: 'membership.planVariantId',
        START_DATE: 'membership.startDate',
        STATUS: 'membership.membershipAttribute',
        TOTAL_BENEFIT_VALUE: 'membership.totalBenefitValue'
    },
    NEW_TAB: 'general.newTab',
    ONTECH: 'ontech.state',
    OrderEdit: {
        CLIENT_NAME: 'general.orderEditClientName',
        INSTALLATION_DATE: 'orderEdit.installationDate',
        ORDER_EDIT: 'orderEdit',
        ORDER_NUMBER: 'orderEdit.orderNumber',
        ORIGINAL_PRICE: 'orderEdit.originalPrice',
        SUB_TOTAL_PRICE: 'orderEdit.subtotalPrice'
    },
    Oss: {
        CUSTOMER_ID: 'oss.customerId',
        CUSTOMER_EMAIL: 'oss.customerEmailAddress',
        CUSTOMER_NAME: 'oss.customerName',
        DEFAULT_ADDRESS: 'oss.defaultAddress',
        DYNAMIC_PRICING_REQUIRE_FULL_PRICE_INSTALL: 'oss.dynamicPricingRequireFullPriceInstall',
        IS_TROUBLE_CALL: 'oss.isTroubleCallOrder',
        PARENT_ORDER_MEMBER_EMAIL: 'oss.parentOrderMemberEmailAddress',
        PARENT_ORDER_MEMBERSHIP_SKU: 'oss.parentOrderMembershipSku',
        PARENT_PARTNER_ID: 'oss.parentPartnerId',
        SESSION_TIMEOUT_DATE: 'oss.timeLastUpdated',
        TECH_DELIVERED: 'oss.techDelivered',
        VALID_GWPS: 'oss.validGwps'
    },
    Partner: {
        PARTNER: 'partner',
        ENABLED_PDP_AVAILABILITY_CHECK: 'partner.pdpAvailabilityCheckEnabled',
        ENABLED_SLIDE_CART: 'partner.slideCartEnabled',
        ID: 'partner.partnerId',
        INDIRECT_PARTNER_CODE: 'partner.indirectPartnerCode',
        LOCK_CLIENT_NAME: 'partner.lockClientName',
        SKIP_CART: 'partner.skipCart',
        URL: 'partner.partnerUrl'
    },
    ParentOrder: {
        IS_MEMBER: 'oss.parentOrderIsMember',
        MEMBERSHIP_INFO: 'oss.parentOrderMembershipInfo',
        NUMBER: 'oss.parentOrderNumber',
        WORK_ORDER: 'oss.parentWorkOrder'
    },
    PassCheckout : {
        ACKNOWLEDGE_FLAG : 'passCheckout.acknowledgeFlag',
        NOTE_ATTRIBUTES: 'passCheckout.noteAttributes',
        METAFIELDS: 'passCheckout.metafields',
        STOP_MONITORING_TIMER: 'passCheckout.stopMonitoringTimer',
        TIME_STAMP: 'passCheckout.timeStamp',
        EMAIL_OF_ORIGINAL_ORDER: 'passCheckout.emailOfOriginalOrder'
    },
    PRODUCT_AVAILABILITY: 'productAvailability',
    Rollbar: {
        PREVIOUS_USER_LOCATION: "rollbar.previousUserLocation"
    },
    Scheduler: {
        ITEMS_NOT_AVAILABLE_MESSAGE: 'scheduler.itemsNotAvailableMessage',
        SCHEDULER: 'scheduler',
        SUBMITTED: 'scheduler.schedulerSubmitted'
    },
    SESSION_ID: 'general.sessionId',
    Settings: {
        BSG_VARIANT_ID: 'settings.bsgVariantId',
        DEFAULT_MEMBERSHIP_VARIANT: 'settings.defaultMembershipVariantId',
        DEFAULT_MONTHLY_MEMBERSHIP_TRIAL_DISPLAY: 'settings.defaultMonthlyMembershipTrialDisplay',
        DEFAULT_MONTHLY_MEMBERSHIP_VARIANT: 'settings.defaultMonthlyMembershipVariantId',
        ENABLE_AJAX_RETRY: 'settings.enableAjaxRetry',
        ENABLE_FORCED_LOGIN_FOR_PARENT_MEMBER: 'settings.enableForcedLoginForParentMember',
        ENABLE_GLOBO_MENU: 'settings.enableGloboMenu',
        ENABLE_LOG_STATE: 'settings.enableLogState',
        ENABLE_METAFIELD_SPECIAL_OFFERS: 'settings.enableMetafieldSpecialOffers',
        ENABLE_METAFIELD_UPSELL: 'settings.enableMetafieldUpsells',
        ENABLE_ORDER_EDITTING: 'settings.enableOrderEditing',
        ENABLE_ORDER_EDIT_TOKEN_SECURITY: 'settings.orderEditTokenSecurityEnabled',
        ENABLE_REFERRER_RESET: 'settings.enableReferrerReset',
        ENABLE_SAVINGS_CALCULATOR: 'settings.enableSavingsCalculator',
        ENABLE_THEME_SCHEDULER: 'settings.enableThemeScheduler',
        ENABLE_TOKEN_SECURITY: 'settings.enableTokenSecurity',
        GOOGLE_SHA_VARIANT_ID: 'settings.googleShaVariantId',
        IS_SHA_ENABLED: 'settings.isShaEnabled',
        IS_SHA_FULL_ENABLED: 'settings.isShaFullEnabled',
        OG_GIFT_CARD_VALUE_AMOUNT: 'settings.ogGiftCardValueAmount',
        OG_PRODUCT_OFFER_ID: 'settings.ogProductOfferId',
        ONTECH_SHA_VARIANT_ID: 'settings.ontechShaVariantId',
        OSS_MEMBERSHIP_VARIANT: 'settings.ossMembershipVariantId',
        OOMA_VARIANT_ID: 'settings.oomaVariantId',
        PAGE_NAME: 'settings.pageName',
        Partners: {
            EXCLUSIVE_TAGS: 'settings.partnerExclusiveTags',
            EXCLUSIVE_CLIENT_NAMES: 'settings.partnerExclusiveClientnames',
            CLIENT_NAME_RESTRICTED: 'settings.partnerClientNameRestricted',
            CLIENT_NAME_RESTRICTED_TWO: 'settings.partnerClientNameRestrictedTwo',
            CLIENT_NAME_RESTRICTED_THREE: 'settings.partnerClientNameRestrictedThree',
            CLIENT_NAME_RESTRICTED_FOUR: 'settings.partnerClientNameRestrictedFour',
            CLIENT_NAME_RESTRICTED_FIVE: 'settings.partnerClientNameRestrictedFive',
            CLIENT_NAME_RESTRICTED_SIX: 'settings.partnerClientNameRestrictedSix',
            SKU_RESTRICTED: 'settings.partnerSkuRestricted',
            SKU_RESTRICTED_TWO: 'settings.partnerSkuRestrictedTwo',
            SKU_RESTRICTED_THREE: 'settings.partnerSkuRestrictedThree',
            SKU_RESTRICTED_FOUR: 'settings.partnerSkuRestrictedFour',
            SKU_RESTRICTED_FIVE: 'settings.partnerSkuRestrictedFive',
            SKU_RESTRICTED_SIX: 'settings.partnerSkuRestrictedSix'
        },
        PREMIUM_SCHEDULE_VARIANT: 'settings.premiumScheduleVariantID',
        PRODUCT_HANDLE: 'settings.productHandleOntech',
        PRODUCT_VARIANT_ID: 'settings.productVariantIdOntech',
        RING_SHA_VARIANT_ID: 'settings.ringShaVariantId',
        ROUTER_DEBUG: 'settings.routerDebug',
        SHOPIFY_ORDER_PREFIX: 'settings.shopifyOrderPrefix',
        SIMPLISAFE_VARIANT_ID: 'settings.simplisafeVariantId',
        SCHEDULER_URL: 'settings.schedulerUrl',
        SERVICE_SCHEDULER_URL: 'settings.serviceSchedulerUrl',
        SUCCESS_URL: 'settings.successUrl',
        SHOPIFY_API_URL: 'settings.shopifyApiUrl',
        TOKEN_DEBUG: 'settings.tokenDebug',
        WYZE_VARIANT_ID: 'settings.wyzeVariantId'
    },
    SHA: 'sha',
    TAG_GUID: 'general.tabGuid',
    Testing: {
        DISABLE_MEMBERSHIP_CART_UPDATE: 'testing.disableMembershipCartUpdate'
    },
    TECH_ID: 'oss.techId',
    VENDOR_DEALS: {
        REFERRER : 'vendor.referrer',
        SLIDE_CART_DISABLED: 'vendor.slideCartDisabled',
        SHOW_EDIT_ZIP_CODE: 'vendor.showEditZipCode',
        CUSTOMER_EMAIL: 'vendor.customerEmail',
        CONTACT_INFO_PAGE_LOAD: 'vendor.contactInfoPageLoad'
    },
    WRITE_ACTIVITY_LOG: false,
    ZIP_CODE: 'general.zipCode',
    UP_TRACKER: 'tracker.upTracker',
    SP_TRACKER: 'tracker.spTracker'
};
 
const StorageConstants = {
    Cache:{
        CART: 'ontech_cache_cart',
        IS_CART_MODIFIED: 'ontech_cache_isCartModified',
        METAFIELDS: 'ontech_cache_metafields',
        PRODUCT_INFO: 'ontech_cache_products',
        PRODUCT_OPTIONS: 'ontech_cache_product_options',
        PREFIX: 'ontech_cache_',
        SHOPIFY_ORDERS: 'ontech_cache_shopify_orders',
        VARIANT_INFO: 'ontech_cache_variants'
    },
    CONTACT_INFO_STEP_URL: 'ontech_contact_info_step_url',
    MEMBERSHIP_PREFIX: 'ontech_membership_',
    OG_STATE: 'OG_STATE',
    OG_VARIANT: 'ontech_ordergroove_variant_id',
    OG_ONLY_ITEM: 'ontech_ordergroove_only_item',
    PAYMENT_URL: 'data.paymentUrl',
    SHOPIFY_ORDER: 'shopifyOrder',
    SHOPIFY_ORDER_NOTES: 'shopifyOrderNotes',
    SHOPIFY_ORDER_ID: 'shopifyOrderId',
    SPECIAL_OFFER_CART_STATE: 'specialOfferCartState',
    SPECIAL_OFFER_ITEMS: 'specialOffersItems',
    THEME_ID: 'ontech_theme_id',
    UPSELL_ITEMS: 'upsellItems',
    SESSION_ID: 'ontech_session_id',
    PREMIUM_INSTALL_INFO: 'PREMIUM_MEMBERSHIP_STORED_INFO',
    PREMIUM_ZIP_RESTRICTED: 'PREMIUM_APPOINTMENT_ZIP_RESTRICTED',
    IS_ASURION_DIAGNOSTIC_OSS :'IS_ASURION_DIAGNOSTIC_OSS'
};

const UserMode = {
    AGENT: 'agent',
    ALL: 'all',
    HOMEPAGE: 'homepage',
    OSS: 'oss'
};

const UrlParams = {
    Partner: {
        ADT: {
            OE: 'OE',
            THIRD_PARTY_AGENT: 'thirdPartyAgentId'
        }
    },
    ACTION: 'action',
    AGENT_ID: 'agentid',
    AUTHORIZATION: 'auth',
    CART_ADDED: 'cartadded',
    CHALLENGE: 'challenge',
    CLIENT_NAME: 'clientname',
    CUSTOMER_SERVICE_NUMBER: 'cs',
    ORDER_NUMBER: 'on',
    OSS_PARENT_ORDER_NUMBER: 'ontech_oss_parent_ordernum',
    OSS_TECH_ID: 'ontech_oss_tech_id',
    PARENT: 'parent',
    PARENT_WORK_ORDER: 'parentWorkOrder',
    PARTNER_ID: 'partnerid',
    ROLE: 'role',
    ROUTE: 'route',
    SITE_NUMBER: 'siteNo',
    TECH_ID: 'techid',
    THEME_ID: 'ontechthemeid',
    TOKEN_ID: 't',
    USER: 'u',
    VARIANT_ID: 'variantId',
    ZIP_CODE: 'zipcode',
    EMAIL: 'em'
}

const WYZE_SKUS = [
    '3592'
];

const IS_ASURION_DIAGNOSTIC_OSS = 'isAsurionDiagnosticOss';
const ASURION_DIAGNOSTIC_OSS_PAGE = '/collections/asurion-agent-hdspcl';

const NewScheduler = {
    LAST_SCHEDULE_DATE_RETURNED : 'lastScheduleDateReturned',
    ZIP_CODE: 'zipcode',
    CART_ITEMS: 'cartItems',
    EMPTY_CAPACITY_RETURNED: 'Empty capacity'
}

// Carousel
const MAX_UPSELLS_IN_CAROUSEL = 5;
const USE_SINGLE_ITEM_FROM_UPSELL_LIST = true;

// OSS
const OSS_SESSION_TIMEOUT_MILISECONDS = 900000; // 15 minutes
//const OSS_SESSION_TIMEOUT_MILISECONDS = 60000; // 1 minute (testing only)
//const OSS_SESSION_TIMEOUT_MILISECONDS = 120000; // 5 minutes (testing only)
//const OSS_SESSION_TIMEOUT_MILISECONDS = 15000; // 15 seconds (testing only)
const OSS_SESSION_TIMEOUT_PAGE_EXCEPTIONS = [
    '/pages/error',
    '/pages/ontech-utilities',
    '/pages/ontech-utilities-hdspcl',
    '/pages/tech-onsite-sales-hdspcl',
    '/pages/tech-onsite-sales',
    '/pages/adt-home-security-on-site-sales-hdspcl'
];
const OSS_SESSION_TIMEOUT_ERROR_PAGE = '/pages/error';
const OSS_SKIP_FORCED_LOGIN = true;

const VALID_EMAIL_REGEX = "^\\s*(?:[A-z0-9!#$%&'*+/=?^_`\\{|\\}~-]+(?:\\.[A-z0-9!#$%&'*+/=?^_`\\{|\\}~-]+)*|\\\"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*\\\")@(?:(?:[A-z0-9](?:[A-z0-9-]*[A-z0-9])?\\.)+[A-z0-9](?:[A-z0-9-]*[A-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[A-z0-9-]*[A-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])\\s*$";